import React from 'react';
import PropTypes from 'prop-types';
import ReactiveRecord, { Member } from 'reactiverecord';

const DemographicSurveyShowSurveyModel = ReactiveRecord.model(
  'DemographicSurveyShowSurvey',
);

let requestedAtLeastOnce = false;
let loadedAtLeastOnce = false;

const DemographicSurveyShowSurvey = ({ children, ...props }) => {
  return (
    <Member
      for={DemographicSurveyShowSurveyModel}
      fetch={!requestedAtLeastOnce}
      {...props}
    >
      {demographicSurveyShowSurvey => {
        requestedAtLeastOnce = true;
        if (/20[0-2]/.test(demographicSurveyShowSurvey._request.status)) {
          loadedAtLeastOnce = true;
        }
        return children(demographicSurveyShowSurvey, loadedAtLeastOnce);
      }}
    </Member>
  );
};

DemographicSurveyShowSurvey.propTypes = {
  children: PropTypes.func.isRequired,
};

export default DemographicSurveyShowSurvey;
